var selectorString = "#joinedOptions option"

// jQuery function to handleize a string
function handleize(string) {
    return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
};

function generateOptions(option) {
    values = [];

    //clear the current options
    $("#" + option + " ul").empty();

    // $("#" + option + " select").empty().append()"<option value=''>Select " + option + "</option>");
    $("#" + option + " select").empty()
    // $("#" + option + " select").empty().append('<option value="">Select ' +  $("#" + option + " select").attr("data-name") + '</option>');


    function addStringToArray(array, str) {
        //  console.log("array", array, str);
        if ($.inArray(str, array) === -1 && str.length > -1) {
            array.push(str);
            return true; // String added to the array
        }
        return false; // String already exists in the array
    };

    $(selectorString).each(function () {
        addStringToArray(values, $(this).attr("data-variant-" + option));
    })

    // Sort the values array for Diameter and Length
    // Given an array of values that could contain values like "#10", "#12", "#14", etc. and values like "1 Inch", "1/2 Inch", "3/4 Inch", etc.
    // Sort the array so that the values are in order of smallest to largest
    // Values starting with a hashtag come before Inch values

    function compareFunction(a, b) {
        // Strip whitespace
        a = a.trim();
        b = b.trim();
      
        // If the first string contains a hashtag, return -1
        if (a.charAt(0) === "#" && b.charAt(0) !== "#") {
            return -1;
        }

        // If the second string contains a hashtag, return 1
        if (a.charAt(0) !== "#" && b.charAt(0) === "#") {
            return 1;
        }

        // If both strings contain a hashtag, compare the two values as numbers
        if (a.charAt(0) === "#" && b.charAt(0) === "#") {
            return parseFloat(a) - parseFloat(b);
        }

        // If both strings contain Inch, compare the two values as numbers after calculating fractions
       if (a.includes("Inch") && b.includes("Inch")) {
            // Get the inch values
            var inchValueA = a.split(" ")[0];
            var inchValueB = b.split(" ")[0];

            var array = [inchValueA, inchValueB];
            var calculatedArray = [];

            // Loop through array
            for (var i = 0; i < array.length; i++) {
              var value = array[i];
              if (value.includes("/")) {
                var fraction = value;
                if (value.includes("-")) {
                  fraction = value.split("-")[1];
                }
                  // Split the fraction into the numerator and denominator
                  var numerator = parseInt(fraction.split("/")[0]);
                  var denominator = parseInt(fraction.split("/")[1]);

                  // Calculate the decimal value of the fraction
                  var calculated = numerator / denominator;

                  if (value.includes("-")) {
                    // Split the fraction into the whole number and fraction
                    var wholeNumber = parseInt(value.split("-")[0]);
                    var calculated = parseFloat(wholeNumber) + parseFloat(calculated);
                  }
              } else {
                // If the fraction is a whole number
                var calculated = parseInt(value);
              }
              calculatedArray.push(calculated);
            }

            return calculatedArray[0] - calculatedArray[1];

        } else {
            return parseFloat(a) - parseFloat(b);
        }
    }

    let optionLabel = $("#" + option + " .options-selection__select label").text();
    if ( optionLabel == 'Length' || optionLabel == 'Diameter' ) {
      values.sort(compareFunction);
    }

    
    //generate the option buttons & select options
    $(values).each(function (index, value) {
        $("#" + option + " ul").append("<li><input type='radio' class='option-radio' name='" + option + "' id='button-" + handleize(value) + "' value='" + value + "'" + " /><label for='button-" + handleize(value) + "'>" + value + "</label></li>");

        var selected = (index === 0)?"selected":"";
        $("#" + option + " select").append("<option "+selected+" value='"+value+"'>" + value + "</option>");
    });

  if ( values.length === 1 ) {
    $('#' + option + ' .options-selection__select').addClass('display-only');
  } else {
    $('#' + option + ' .options-selection__select').removeClass('display-only');
  }


    //when a button is clicked, generate the next set of options
    $("input.option-radio").on("click", function(e) {
        processOptionSelection(this)
    })

}

function calculatePrice() {

    // if variant is available, calculate the price
    if ( $(selectorString).first().attr("data-variant-available") === "true" ) {
        price = $(selectorString).first().attr("data-variant-price");
        minquantity = (parseInt($(selectorString).first().attr("data-variant-min-quantity"))>1)? parseInt($(selectorString).first().attr("data-variant-min-quantity")) : 1;

        //adjust the mininimums
        $("input[name=quantity]").val(minquantity).attr("min", minquantity);
        $("#joinedOptions option").removeAttr("selected");
        $("variant-selection").attr("variant", $(selectorString).first().val())
        $("variant-selection").attr("product-url", "/products/" + $(selectorString).first().attr("data-variant-product-handle") + ".js")

        // Force the other variant-selection select (from the theme add to cart form) to select the chosen variant
        // var variantID = $(selectorString).first().val();
        // $("form[data-product-form] variant-selection select").append('<option value="'+variantID+'" selected>Testing</option>');
      
        //update the price display
        calculateQuantityPrice();
        $("#joinedOptionsCartForm").find('button[type=submit]').attr("disabled");
        $("#joinedOptionsCartForm").find('button[type=submit] .atc-button--text').text("Add to Cart");
        $(selectorString).first().attr("selected", "selected");

        // Set the theme form variant-selection
        $("form[data-product-form] variant-selection").attr("variant", $(selectorString).first().val());
        $("form[data-product-form] .variant-selection__variants").find("option:disabled").remove();
        $("form[data-product-form] .variant-selection__variants option").first().val($(selectorString).first().val()).attr("selected", "selected");
        $('form[data-product-form] variant-selection').attr("product-url", "/products/" + $(selectorString).first().attr("data-variant-product-handle") + ".js");

        $("#joinedOptionsCartForm").find('button[type=submit]').removeAttr("disabled");
        

    }
    //variant not available
    else{

        $("#joinedOptionsCartForm").find('button[type=submit]').text("Out of stock");
        $("#joinedOptionsCartForm").find('[name=quantity]').val(0);
        $("#joinedOptionsCartForm").find('button[type=submit],[name=quantity]').attr("disabled", "disabled");


    }

    $("#joinedOptionsCartForm").show();

}

function calculateQuantityPrice(){
    price =parseFloat($(selectorString).first().attr("data-variant-price"));
    qty = parseInt($("[name=quantity]").val());

    $("#variantPrice").html("@ $" + ((parseInt(price)) / 100).toFixed(2) + "/each <br /> = $" + ((((parseInt(price)).toFixed(2)) / 100) * parseInt(qty)).toFixed(2));

}

function selectVariantImage() {
  var selectedVariant = $('.variant-selection').attr('variant');
  // Make API call to get variant's image_id
  var token = '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';
  var url = 'gid://shopify/ProductVariant/'+selectedVariant;
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Access-Token': token,
    },
  })
  .then((response) => response.json())
  .then((data) => {
    // console.log(data);
  })
  .catch((error) => {
    console.log(error);
  });
  // Click on the image with the image_id
}

var processedOptions = [];
// Added processedOptions array to semi-fix issue where selecting an option caused memory to continuously grow until page crashes
// Still not entirely fixed - the first option selected still exponentially grows, but not sure the user will notice.

function processOptionSelection(element) {

    if ( processedOptions.includes($(element).attr('name')) ) {
      return false;
    }

    processedOptions.push($(element).attr('name'));
  
    //update selectedOptionsObject & selectorString
    selectorString = "#joinedOptions option";
    $("input.option-radio:checked").each(function () {
       // console.log("current option:", parseInt($(element).attr("name").match(/\d/)[0]));
        //console.log("checking option:", parseInt($(this).attr("name").match(/\d/)[0]));
        if (parseInt($(this).attr("name").match(/\d/)[0]) <= parseInt($(element).attr("name").match(/\d/)[0])) {
            selectorString = selectorString + "[data-variant-" + $(this).attr("name") + "='" + $(this).val() + "']"
          //  console.log("updated selectorString:", selectorString)
        }
    })

    //get the current option
    currentOption = $(element).attr("name");

    //update the selectedoption span
    $("#" + currentOption + " h4 span").html(" " + $(element).val() + " <span>Click to Change</span>");

    //if there are more options, generate them
    if ($(element).parents(".splitOptionGroup").nextAll(".splitOptionGroup").length > 0) {
        nextOption = $(element).parents(".splitOptionGroup").nextAll(".splitOptionGroup").attr("id");
        //hide the cart form
        $("#joinedOptionsCartForm").hide();
        generateOptions(nextOption);
        //open the next set of options by clicking its radio button
      // console.log($("#radio-" + nextOption));
        $("#radio-" + nextOption).removeAttr("disabled").click();
        //if there is only one option, select it
        // if ($("#"+nextOption +" li").length === 1) {
        //     $("input[type=radio][name=" + nextOption + "]").first().click();
        // }
        //select the first option
        $("input[type=radio][name=" + nextOption + "]").first().click();


    }
    //if there are no more options, calculate the price
    else {
        // console.log("no more options. calculate the price");
        calculatePrice();
        // selectVariantImage();
    }
}

//binds plus and minus buttons to the quantity selector.
$("#joinedOptionsCartForm .quantity-selector__wrapper button").on("click", function() {
    let input = $(this).parent().siblings("input[name=quantity]");
    //     change = $(this).attr("name") === "plus" ? 1 : -1,
    //     newVal = Math.max(parseInt(input.val()) + change, parseInt(input.attr('min')));
    // input.val(newVal);
    input.trigger("change");
});

$("#joinedOptionsCartForm input[name=quantity]").on("change", function() {
    $(this).val(Math.max($(this).val(), $(this).attr('min')));
    //update the price display
    calculateQuantityPrice();
});

//link select options to now hidden buttons

$(".optionsSelect").on("change", function(){
    processedOptions = []; // Clear our processedOptions when a new selection takes place
    $("input[type=radio][name='"+$(this).attr("id").replace("select-","")+"'][value='"+$(this).find(":selected").val()+"']").click();
});

// Hijack the custom form Add to Cart button and use it to click the hidden theme form's Add to Cart button
$('#joinedOptionsCartForm .product-form--atc-button').on('click', function(e){
  e.preventDefault();
  var quantity = $('#joinedOptionsCartForm .quantity-selector__input').val();
  $("form[data-product-form] .quantity-selector__input").val(quantity);
  $("form[data-product-form] .product-form--atc-button").removeAttr("disabled").click();
  $(this).addClass("processing");
  setTimeout(function(){
    $('#joinedOptionsCartForm .product-form--atc-button').removeClass("processing");
  }, 1000);
})


//init
//generate initial options
generateOptions("option1")

//set initial selector on load
$("select.optionsSelect").first().trigger("change")



